import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {

  messageEnabled: boolean = false;
  resellerEnabled: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  tabChanged(tabChangeEvent) {
    if(tabChangeEvent == 1) {
      this.router.navigate(['/message']);
    } else  if(tabChangeEvent == 2){
      this.router.navigate(['/reseller']);
    }
    else  if(tabChangeEvent == 3){
      this.router.navigate(['/resellermessage']);
    }
    else  if(tabChangeEvent == 4){
      this.router.navigate(['/monthlyactiveuser']);
    }
    else if(tabChangeEvent == 5){
      console.log("path whatsapppricing")
      this.router.navigate(['/whatsapppricing']);
    }
  }
}
